import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PosService } from '../../service/pointofsale.service';
import { SpinnerService } from '../../service/spinner.service';
import { finalize, Subscription } from 'rxjs';
import { StatusPOS } from '@/enum/statusPOS';
import { TranslateService } from '@ngx-translate/core';
import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';


const GOOGLE_MAPS_API_KEY: string = window.env.googleMapsAPIKey;

const mapLoaderOptions: LoaderOptions = {
  apiKey: GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places', 'drawing', 'visualization', 'geometry'],
  language: "fr",
  region:"fr",
}

const mapOptions = {
  center: {
    lat: 48.8773595,
    lng: 2.2885282
  },
  zoom: 12
}

@Component({
  selector: 'app-pointofsaledetails',
  templateUrl: './pointofsaledetails.page.html',
  styleUrls: ['./pointofsaledetails.page.scss']
})
export class PointofsaledetailsPage implements OnInit, OnDestroy {
  dataForm: FormGroup;
  private network_reference: string;
  private unsubscribe: Subscription[] = [];
  public StatusPOS: typeof StatusPOS = StatusPOS;
  @ViewChild('selectOption') selectOption: any;
  objectKeys = Object.keys;
  open_hours = undefined;
  public map: any;
  private markers = [];
  private lonlatset = false;
  private lat = 0;
  private lon = 0;
  constructor(private _location: Location, private formBuilder: FormBuilder, private router: ActivatedRoute, private posService: PosService,
    private spinnerService: SpinnerService, private translateService: TranslateService) { }

  ngOnInit() {
    const mapLoader = new Loader(mapLoaderOptions);
    mapLoader
      .load()
      .then((google) => {
        this.map = new google.maps.Map(document.getElementById("mapPOS"), mapOptions);
        this.setPositiongoogle();
      })
      .catch(e => {
        console.log(e);
      });

    this.network_reference = this.router.snapshot.paramMap.get('id')
    this.dataForm = this.formBuilder.group({
      city: [''],
      deposit: [''],
      last_update: [''],
      network: [''],
      network_reference: [''],
      status: [''],
      store: [''],
      email: [''],
      address_line_1: [''],
      zip: [''],
      country: [''],
      latitude: [''],
      longitude: [''],
      phone: [''],
      mobile: [''],
      deposit_limit: [''],
      open_hours: [''],
    });



    this.unsubscribe.push(
      this.posService.getByNetwork_reference(this.network_reference).pipe(finalize(() => {
        this.spinnerService.hide();
      })).subscribe(val => {
        this.dataForm.patchValue({
          city: val.city,
          deposit: val.deposit,
          last_update: val.last_update,
          network: val.network,
          status: this.translateService.instant(this.StatusPOS[val.status]),
          network_reference: val.net_ref,
          store: val.storename,
          email: val.email,
          address_line_1: val.address,
          zip: val.zipcode,
          country: val.country,
          latitude: val.latitude,
          longitude: val.longitude,
          phone: (val.phone && val.phone !== 'nan') ? val.phone : '',
          mobile: (val.mobile && val.mobile !== 'nan') ? val.mobile : '',
          deposit_limit: val.deposit_limit,
          open_hours: val.openinghours,
        });
        this.lat = val.latitude;
        this.lon = val.longitude;
        this.setPositiongoogle();
        this.open_hours = val.openinghours
      }
      ));
  }

  setPositiongoogle() {
    if (this.map && this.lonlatset === false && this.lat !== 0 && this.lon !== 0) {
      this.lonlatset = true;
      this.map.setCenter(new google.maps.LatLng(this.lat, this.lon));
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(this.lat, this.lon),
        map: this.map,
        title: ''
      });
      this.markers.push(marker);
    }
  }

  get f() { return this.dataForm.controls; }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
    this.markers = [];
  }

  renderDateOpenHours() {
    const orderRender = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    let result = {}
    var arr = [];

    orderRender.forEach(item => {
      let dataDate = Object.keys(this.open_hours).find(e => e.toLowerCase() == item.toLowerCase())
      if (dataDate === undefined)
        dataDate = item;
      //dataDate = this.translateService.instant(dataDate.toLowerCase());
      result[dataDate] = this.open_hours[dataDate]

    })
    for (var key in result) {
      if (result.hasOwnProperty(key)) {
        arr.push([this.translateService.instant(key), result[key]]);
      }
    }
    return arr
  }

  handleChangeCustomer(e) {
    let txt_placeholder = e.target.value || ''
    this.selectOption.nativeElement.value = ''
    this.dataForm.patchValue({
      status: txt_placeholder
    })
    this.selectOption.nativeElement.setAttribute('placeholder', txt_placeholder)
  }

  renderTimeOfDate(arrTime?: Array<string>) {
    if (!arrTime) return ""
    return arrTime.join(' - ')
  }

  goBack() {
    this._location.back()
  }
}
